import React, { useState, useEffect } from "react";

const detectRussian = () => {
  const lang = navigator.language || navigator.userLanguage || '';
  return lang.startsWith('ru');
};

export default function BackendUnavailableBanner() {
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    const handler = (e) => setUnavailable(!e.detail.available);
    window.addEventListener('backend-availability-change', handler);
    return () => window.removeEventListener('backend-availability-change', handler);
  }, []);

  if (!unavailable || (typeof navigator !== 'undefined' && navigator.onLine === false)) return null;

  const isRussian = detectRussian();
  const message = isRussian
    ? "WowContent сейчас недоступен. Подождите несколько секунд - скорее всего идет релиз новой версии 🙈"
    : "WowContent is currently unavailable. Wait a few seconds - it's likely release of a new version 🙈";

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10000,
        backgroundColor: '#fff3cd',
        color: '#664d03',
        padding: '10px 16px',
        textAlign: 'center',
        fontSize: 14,
        lineHeight: 1.4,
        borderBottom: '1px solid #ffecb5',
        paddingTop: 'calc(10px + env(safe-area-inset-top))',
      }}
    >
      {message}
    </div>
  );
}
